import { render, staticRenderFns } from "./passengerflow.vue?vue&type=template&id=2f60b05a&scoped=true"
import script from "./passengerflow.vue?vue&type=script&lang=js"
export * from "./passengerflow.vue?vue&type=script&lang=js"
import style0 from "./passengerflow.vue?vue&type=style&index=0&id=2f60b05a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60b05a",
  null
  
)

export default component.exports